import { render, staticRenderFns } from "./OptionalCoverageItem.vue?vue&type=template&id=4e5b8a28"
import script from "./OptionalCoverageItem.vue?vue&type=script&lang=js"
export * from "./OptionalCoverageItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports